import * as React from "react";
import { Title as MantineTitle } from "@mantine/core";
import styled, { css } from "styled-components";
const fontSizeForOrder = (order, theme) => {
  const sizes = {
    1: theme.fonts.size.h1,
    2: theme.fonts.size.h2,
    3: theme.fonts.size.h3,
    4: theme.fonts.size.h4,
    5: theme.fonts.size.h5,
    6: theme.fonts.size.h6
  };
  return sizes[order];
};
const StyledTitle = styled(MantineTitle)(
  ({ theme, order }) => css`
    font-size: ${fontSizeForOrder(order, theme)};
    font-family: ${order <= 2 ? theme.fonts.family.navigation : "inherit"};
    font-weight: ${order === 6 ? "bold" : "normal"};
    color: ${theme.colors.text.primary};
    margin: 0;
    padding: 0;
  `
);
const Title = ({ order = 1, ...props }) => /* @__PURE__ */ React.createElement(StyledTitle, { order, ...props });
export default Title;
